export default "__VITE_ASSET__x0Z1iZ_B__"